import { getPaymentStatus } from "@/utility/common";
import React from "react";
import "./PaymentStatus.scss";

const PaymentStatusColorCode = ({ paymentStatus }: { paymentStatus: any }) => {
  let statusColorCode: any = {
    0: {
      circleColor: "grey",
      chipBackground: "none",
      chipOutLine: "#cfcdcd",
      textColor: "black",
    },
    1: {
      circleColor: "#197335",
      chipBackground: "#e7fce8",
      chipOutLine: "#e7fce8",
      textColor: "#197335",
    },
    2: {
      circleColor: "white",
      chipBackground: "#52565d",
      chipOutLine: "#52565d",
      textColor: "white",
    },
    4: {
      circleColor: "#a40011",
      chipBackground: "#fcf5f3",
      chipOutLine: "#fcf5f3",
      textColor: "#a40011",
    },
    5: {
      circleColor: "#0080ff",
      chipBackground: "#66b3ff17",
      chipOutLine: "#66b3ff17",
      textColor: "#0080ff",
    },
    6: {
      circleColor: "grey",
      chipBackground: "#e0e0e069",
      chipOutLine: "#e0e0e069",
      textColor: "black",
    },
  };
  if (
    paymentStatus === "" ||
    paymentStatus === undefined ||
    paymentStatus === null
  ) {
    return <>-</>;
  }
  return (
    statusColorCode?.[paymentStatus]?<div className="statusChipContainer">
      <div
        className="statusChip"
        style={{
          background: statusColorCode?.[paymentStatus]?.chipBackground,
          outline: `1px solid ${statusColorCode?.[paymentStatus]?.chipOutLine}`,
        }}
      >
        <span
          className="statusChipCircle"
          style={{
            backgroundColor: statusColorCode?.[paymentStatus]?.circleColor,
          }}
        ></span>
        <span
          className="statusChipText"
          style={{
            color: statusColorCode?.[paymentStatus]?.textColor,
          }}
        >
          {getPaymentStatus(paymentStatus)}
        </span>
      </div>
    </div>:<>{getPaymentStatus(paymentStatus)}</>
  );
};

export default PaymentStatusColorCode;
